import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateRouterLinkPipe, EnvService } from '../../core';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateRouterLinkPipe, TranslateModule, RouterModule],
})
export class FooterComponent {
  labelPrefix = 'FOOTER.';
  links = this.translateService.instant(this.labelPrefix + 'LINKS');
  isLoggin = false;
  currentYear: number = new Date().getFullYear();

  constructor(
    private readonly translateService: TranslateService,
    private readonly authService: AuthService,
    public readonly envService: EnvService
  ) {
    this.authService.getUser().subscribe((response: any) => {
      this.isLoggin = response.user.userId;
    });

    this.translateService.onLangChange.subscribe((labels: any) => {
      this.links = this.translateService.instant(this.labelPrefix + 'LINKS');
    });
  }
}
